module.exports = __webpack_public_path__ + "static/img/yagi_05.63a92a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yagi_05.jpg
// module id = lyRf
// module chunks = 0